const IframeAdapter = () => {
  // If we are in pop up, close.
  if (window.opener && window.opener !== window) {
    window.opener.postMessage({ type: "lpg.iframe.close" }, "*");
    window.close();
    return null;
  }

  // If we are not in an iframe, do nothing.
  if (window.location === window.parent.location) return null;

  document.body.style.backgroundColor = "transparent";
  document.body.addEventListener("keyup", e => {
    if (e.key === "Escape") {
      const event = { type: "lpg.iframe.close" };
      window.parent.postMessage(event, "*");
    }
  });
  return null;
};

export default IframeAdapter;
